<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="clientContractMaterials"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="合同类型" prop="clientContractType">
            <el-select v-model="filter.clientContractType" clearable>
              <el-option label="渠道商协议" :value="10"/>
              <el-option label="框架合同" :value="20"/>
              <el-option label="产品销售合同" :value="30"/>
              <el-option label="产品借用转销售合同" :value="40"/>
              <el-option label="试用协议" :value="50"/>
              <el-option label="备品协议" :value="60"/>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="合同状态" prop="clientContractType" clearable>-->
          <!--            <el-select v-model="filter.status">-->
          <!--              <el-option label="草稿" :value="0"/>-->
          <!--              <el-option label="已提交" :value="1"/>-->
          <!--              <el-option label="已审批" :value="3"/>-->
          <!--              <el-option label="驳回" :value="4"/>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="合同编号" prop="clientContractNo">
            <el-input v-model="filter.clientContractNo" clearable/>
          </el-form-item>
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="filter.customerName" clearable/>
          </el-form-item>
          <el-form-item label="行项类型" prop="rowType">
            <el-select v-model="filter.rowType" clearable>
              <el-option label="销售物料" :value="'销售物料'"/>
              <el-option label="虚拟抬头" :value="'虚拟抬头'"/>
            </el-select>
          </el-form-item>
          <el-form-item label="期望交期">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
          <el-form-item label="提交时间">
            <el-date-picker
                v-model="submitTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('submitTimeRange', 'submitTimeBegin', 'submitTimeEnd')"/>
          </el-form-item>
          <el-form-item label="通过时间">
            <el-date-picker
                v-model="passTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
          </el-form-item>
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="filter.materialName" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <!--   <template slot="actionBtn" slot-scope="scope"> -->
      <!--        <el-button -->
      <!--            v-if="limits.subAuth"-->
      <!--            type="success"-->
      <!--            :disabled="scope.row.status===3 || scope.row.status===1"-->
      <!--            :loading="submitLoading"-->
      <!--            @click="submit(scope.row)">-->
      <!--          提交-->
      <!--        </el-button>-->
      <!--        <el-button-->
      <!--            v-if="limits.rejectAuth"-->
      <!--            type="primary"-->
      <!--            :disabled="scope.row.status !== 3"-->
      <!--            :loading="rejectLoading"-->
      <!--            @click="reject(scope.row)">-->
      <!--          驳回-->
      <!--        </el-button>-->
      <!--     </template>-->
    </viewTable>
    <client-contract-edit ref="clientContractEditPage" @save-success="loadData"/>
  </div>
</template>

    <script>
  import viewTable from "@/components/ViewTable.vue";
  import ClientContractEdit from "@/views/SalesManage/SalesClientContract/ClienContractEdit";

  export default {
    name: "ClientContractMaterial",
    components: {ClientContractEdit, viewTable},
    data() {
      return {
        submitLoading: false,
        passLoading: false,
        rejectLoading: false,
        limits: {
          editAuth: this.$auth(292),
          addAuth: this.$auth(235),
          delAuth: this.$auth(294),
          subAuth: this.$auth(236),
          passAuth: this.$auth(293),
          rejectAuth: this.$auth(315),
        },
        filter: {
          clientContractNo: "",
          customerNo: "",
          customerName: "",
          clientContractType: "",
          creatorName: "",
          status: "",
          createTimeBegin:"",
          createTimeEnd:"",
          submitTimeBegin:"",
          submitTimeEnd:"",
          passTimeBegin:"",
          passTimeEnd:"",
          available:"",
        },
        selection: [],
        materialType: [],
        createTimeRange:[],
        submitTimeRange:[],
        passTimeRange:[],
        columnsProperty: [
          {
            key: "materialNo",
            width: 160,
            align: "center",
          },
          {
            key: "clientContractTypeName",
            width: 120,
            align: "center",
          },
          {
            key: "clientContractNo",
            width: 160,
            align: "center",
          },
          {
            key: "materialName",
            width: 160,
            align: "center",
          },
          {
            key: "specification",
            width: 60,
            align: "center",
          },
          {
            key: "quantity",
            width: 60,
            align: "center",
          },
          {
            key: "unitPrice",
            width: 60,
            align: "center",
          },
          {
            key: "unit",
            width: 60,
            align: "center",
          },
          {
            key: "rowIndex",
            width: 60,
            align: "center",
          },
          {
            key: "rowType",
            width: 120,
            align: "center",
          },
          {
            key: "deliveryDate",
            width: 120,
            align: "center",
          },
          {
            key: "manufacturerModel",
            width: 120,
            align: "center",
          },
          {
            key: "standardDeliveryTime",
            title: "标准交期(天)",
            width: 120,
            align: "center",
          },
          {
            key: "refBillNo",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "note",
            width: 120,
            align: "center",
          },
          // {
          //   key: "statusDesc",
          //   width: 120,
          //   align: "center",
          // },
          // {
          //   key: "clientContractNo",
          //   width: 300,
          //   align: "center",
          //   tooltip: true,
          //   render: (h, params) => {
          //     return h(
          //       "span",
          //       {
          //         style: {
          //           color: "#2d8cf0",
          //           cursor: "pointer",
          //         },
          //         on: {
          //           click: () => {
          //             this.$refs.clientContractEditPage.open(params.row, true);
          //           },
          //         },
          //       },
          //       params.row.clientContractNo,
          //     );
          //   },
          // },
          // {
          //   key: "customerClientContractNo",
          //   minWidth: 360,
          //   align: "center",
          //   tooltip: true,
          // },
          // {
          //   key: "clientContractName",
          //   minWidth: 360,
          //   align: "center",
          //   tooltip: true,
          // },
          // {
          //   key: "customerName",
          //   minWidth: 360,
          //   align: "center",
          //   tooltip: true,
          // },
          // {
          //   key: "customerNo",
          //   minWidth: 150,
          //   align: "center",
          //   tooltip: true,
          // },
          // {
          //   key: "urgent",
          //   minWidth: 100,
          //   align: "center",
          //   tooltip: true,
          // },
          // {
          //   key: "clientContractDeliveryDate",
          //   width: 140,
          //   tooltip: true,
          // },
          // {
          //   key: "clientContractAmount",
          //   width: 100,
          //   align: "center",
          // },
          // {
          //   key: "creatorName",
          //   width: 100,
          //   align: "center",
          // },
          // {
          //   key: "createTime",
          //   minWidth: 200,
          //   tooltip: true,
          // },
          // {
          //   key: "submitTime",
          //   minWidth: 200,
          //   tooltip: true,
          // },
          // {
          //   key: "passTime",
          //   minWidth: 200,
          //   tooltip: true,
          // },
          // {
          //   key: "businessOperatorName",
          //   width: 100,
          //   align: "center",
          // },
          // {
          //   key: "clientContractAbstract",
          //   width: 120,
          //   align: "center",
          // },
          // {
          //   key: "action",
          //   align: "center",
          //   width: 300,
          //   slot: "action",
          //   fixed: "right",
          // },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.clientContractEditPage.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "clientContracts", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      submit(row) {
        this.submitLoading = true;
        this.$http.get("basic", `clientContracts/submitOA/${row.pkId}`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("提交成功");
            this.submitLoading = false;
          }
        }).finally(() =>
          this.submitLoading = false);
        this.submitLoading = false;
      },

      reject(row) {
        this.rejectLoading=true;
        this.$http.get("basic",`clientContracts/reject/${row.pkId}`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("驳回成功");
            this.rejectLoading = false;
          }
        }).finally(() =>
          this.rejectLoading = false);
        this.rejectLoading = false;
      },

      otherAuth(row) {
        if (row.status === 0 || row.status === 4) {
          return false;
        } else {
          return true;
        }
      },

      pass(row) {
        this.passLoading = true;
        this.$http.get("basic", `clientContracts/getOaResult/${row.pkId}/1`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("提交成功");
            this.passLoading = false;
          }
        }).finally(() =>
          this.passLoading = false);
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      goto(row) {
        const routeUrl = this.$router.resolve({
          path: "/ClienContractPreview",
          query: {
            billId: row.pkId,
            $tabName: row.clientContractNo,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      onHandleContractPreview(url) {
        let pkId = "";
        if(this.selection.length===0) {
          this.$message.warning("请选择要预览的合同");
          return;

        } else if(this.selection.length>1) {
          this.$message.warning("只能选择一条合同进行预览");
          return;
        } else {
          pkId= this.selection[0].pkId;
        }
        const routeUrl = this.$router.resolve({
          path: url,
          query: {
            id:pkId,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
    },
  };
    </script>